import { render, staticRenderFns } from "./DiamondComponent.vue?vue&type=template&id=49d3ed7b&scoped=true"
import script from "./DiamondComponent.vue?vue&type=script&lang=js"
export * from "./DiamondComponent.vue?vue&type=script&lang=js"
import style0 from "./DiamondComponent.vue?vue&type=style&index=0&id=49d3ed7b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d3ed7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d3ed7b')) {
      api.createRecord('49d3ed7b', component.options)
    } else {
      api.reload('49d3ed7b', component.options)
    }
    module.hot.accept("./DiamondComponent.vue?vue&type=template&id=49d3ed7b&scoped=true", function () {
      api.rerender('49d3ed7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/DiamondComponent.vue"
export default component.exports